import en from "./en-US";
import cs from "./cs-CZ";

const intlMessages: { [key: string]: { [key: string]: string } } = {
  "cs-CZ": cs,
  "en-US": en,
};

export default intlMessages;
